import * as React from "react";
import {renderSelect, renderTextField, Fields} from "userform/utils";
import {IReduxState} from "../reducers";
import { connect } from "react-redux";
import {hideConsentLoader, showConsentLoader} from "consent/actions";
import {ILoanApprovalInfo} from "../StateInterface";
import {notifyAndroidOfLoanDeclined} from "utils/android";
import ConsentBox from "consent/utils/consentBox";
import {SelectField} from "consent/utils/selectField";
import RoundedButton from "components/roundedButton";
import TextContainer from "consent/utils/textContainer";
import TextField from "consent/utils/textField";
import {markConsent} from "consent/api";
import {getLatestLoanOpp} from "consent/actions";
import {EventName, updateConsentEvent} from "consent/events";
import "consent/styles.scss";
import {partnerOfferings} from "login/config";

interface IConnectProps {
    dispatch?: (action: any) => void;
    userId: number;
    loanApprovalInfo: ILoanApprovalInfo;
    lenderOpportunityId: string;
    config: any;
    isAndroid: boolean;
    isPartnerAndroid: boolean;
    utm_source: string;
}
interface IState {
    reasonError: string;
    loanFromOtherSourceError: string;
    reason: string;
    otherSource: string;
    otherSourceError: string;
}

const options  = ["I want Higher loan amount",
"I have already got a loan",
"The interest rate is high"];
class ConsentDenied extends React.Component<IConnectProps, IState> {
    constructor(props) {
        super(props);
        this.state = {
            reasonError: null,
            loanFromOtherSourceError: null,
            reason: "Select your reason",
            otherSource: null,
            otherSourceError: null,
        };
        this.onChange = this.onChange.bind(this);
        this.handleAcceptOffer = this.handleAcceptOffer.bind(this);
        this.handleDeclineOffer = this.handleDeclineOffer.bind(this);
    }

    public onChange(fieldName, value) {
        if (fieldName === Fields.CONSENT_DENY_REASON) {
            const otherSourceError = this.state.otherSourceError;
            this.setState({reason: options[Number(value)], reasonError: null,
                otherSourceError: Number(value) === 1 ? otherSourceError : null});
        } else if (fieldName === Fields.LOAN_OTHER_SOURCE) {
            this.setState({otherSource: value, otherSourceError: null});
        }
    }

    public renderOfferDenyReason() {
        const optionsList = options.map((item, index) => {
            return {name: item, value: String(index)};
        });
        optionsList.unshift({name: "Please Select your reason", value: String(-1)});
        return SelectField("Select your reason",
            optionsList,
            options.indexOf(this.state.reason),
            Fields.CONSENT_DENY_REASON,
            null,
            this.onChange,
            null,
            null,
            {fontSize: 15, color: "#000", fontWeight: 700, float: "left"},
        );
    }

    public renderErrorMessage() {
        let error = null;
        if (this.state.reasonError) {
            error = this.state.reasonError;
        } else if (this.state.otherSourceError) {
            error = this.state.otherSourceError;
        }
        return error ?
        <div className="alert alert-danger" style={{fontSize: 12}}>
            {error}
        </div>
        : <div/>;
    }

    public renderSuggestion() {
        const suggestion = [
            <TextContainer text="MyShubhLife gives the highest loan amount in the market
            considering your salary and current obligations" fontSize={12} />,
            <div>
                {this.renderOtherSource()}
            </div>,
            <TextContainer text="MyShubhLife interest rate is on reducing balance.Your flat interest rate is less than 1.5% per month!" fontSize={12} />];

        return options.indexOf(this.state.reason) !== -1
        ? suggestion[options.indexOf(this.state.reason)]
        : <div/>;
    }

    public handleAcceptOffer() {
        markConsent(this.props.lenderOpportunityId, true, null).then((res) => {
            updateConsentEvent(EventName.ACCEPT_LOAN_OFFER, true);
            if (res.status === 200) {
                this.props.dispatch(getLatestLoanOpp(this.props.lenderOpportunityId));
            }
        });
    }

    public handleDeclineOffer() {
        const validationResult = this.validation();
        if (validationResult.status) {
            const comments = ["CONSENT_DENIED_REASON: Higher Loan Amount Needed",
           "CONSENT_DENIED_REASON: Got Loan from - " + this.state.otherSource,
           "CONSENT_DENIED_REASON: Lower Interest Rate Needed"];
            this.setState({reasonError: null, otherSourceError: null});
            const comment = comments[options.indexOf(this.state.reason)];
            this.props.dispatch(showConsentLoader());
            markConsent(this.props.lenderOpportunityId, false, comment).then((res) => {
                updateConsentEvent(EventName.ACCEPT_LOAN_OFFER, false);
                if (res.status === 200) {
                    if (this.props.isAndroid && !this.props.isPartnerAndroid) {
                        notifyAndroidOfLoanDeclined("DECLINED");
                    }
                    this.props.dispatch(getLatestLoanOpp(this.props.lenderOpportunityId));
                } else {
                    this.props.dispatch(hideConsentLoader());
                }
            });

        } else {
            this.setState({reasonError: validationResult.reasonError,
            otherSourceError: validationResult.otherSourceError});
        }
    }

    public validation() {
        const reasonError = options.indexOf(this.state.reason) === -1
        ? "Please select one of the options to proceed." : null;
        const otherSourceError = options.indexOf(this.state.reason) === 1
        && !this.state.otherSource ? "Please mention where did you get the loan offer." : null;
        return {
            reasonError,
            otherSourceError,
            status: !reasonError && !otherSourceError,
        };
    }

    public renderOtherSource() {
        return <TextField
            type="text"
            placeholder=""
            value={this.state.otherSource}
            fieldName={Fields.LOAN_OTHER_SOURCE}
            label="Where did you get your loan from?"
            onChange={(value) => this.onChange(Fields.LOAN_OTHER_SOURCE, value)}
        />;
      }

    public render() {
        return <ConsentBox>
                <div style={{textAlign: "center", fontSize: 15}}>
                    <div>You are one click away from ₹ <span style={{fontWeight: "bold"}}>{this.props.loanApprovalInfo
                        ? this.props.loanApprovalInfo.amount : null}</span>
                    </div>
                    <div>Tell us why you don't want this loan.</div>
                </div>
                <form>
                    <div style={{marginTop: 30}}>
                        {this.renderOfferDenyReason()}
                        {this.renderSuggestion()}
                    </div>
                    {this.renderErrorMessage()}
                    <div className="flex-column-center-row" style={{marginTop: 10}}>
                        <RoundedButton
                            bgColor={partnerOfferings[this.props.utm_source]?.colors?.green}
                            buttonText={"Deny Loan Offer"}
                            onClick={() => this.handleDeclineOffer()}
                            size="small" />
                        <div className="accept-button-wrapper">
                            Changed your mind? <span style={{color: `${partnerOfferings[this.props.utm_source]?.colors ? partnerOfferings[this.props.utm_source]?.colors?.green : "#F58220"}`}} onClick={() => this.handleAcceptOffer()}>Accept Loan Offer</span>
                        </div>
                    </div>
                </form>
            </ConsentBox>;
    }
}

const mapStateToProps = (state: IReduxState) => {
    return {
        userId: state.login.auth.userId,
        loanApprovalInfo: state.consent.loanApprovalInfo ? state.consent.loanApprovalInfo : null,
        lenderOpportunityId: state.consent.lenderOpportunityId,
        config: state.userform.config,
        isAndroid: state.login.isAndroid,
        isPartnerAndroid: state.login.isPartnerAndroid,
        utm_source: state.login.authExt && state.login.authExt.utm_source ? state.login.authExt.utm_source : null,
    };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(ConsentDenied);
